import { Alert, AlertDescription, AlertIcon, AlertTitle, Button, Divider, FormControl, FormLabel, Input, InputGroup, InputLeftElement, InputRightElement, Select, Stack } from "@chakra-ui/react";
import AutoComplete from "components/autocomplete/AutoComplete";
import Card from "components/card";
import { useEffect, useState } from "react";
import { FaCheck, FaTrash } from "react-icons/fa";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { message } from "utils/Funciones";
import { currencyFormat } from "utils/Funciones";

function TableCartItemsPos({ userCart, onRemoveFromCart, onIncreased, onDecreased, loading, onApplyDiscount, onUpdateMetodoPago, metodopagoval }) {

    const [descuento, setDescuento] = useState(userCart.cart?.cartItems?.length > 0 ? userCart.cart?.descuento : 0)

    useEffect(() => {
        if (userCart.cart?.cartItems?.length < 1) {
            setDescuento(0)
        }
    }, [userCart.cart?.descuento])

    return (
        <Card extra="w-full h-full sm:overflow-x-auto">
            <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
                <table class="w-full text-sm text-left rtl:text-right text-navy-500 dark:text-navy-400">
                    <thead class="text-xs text-navy-900 uppercase bg-navy-50 dark:bg-navy-700 dark:text-navy-200">
                        <tr>
                            <th scope="col" className="px-7 py-3">
                                <span class="sr-only">Image</span>
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Producto / servicio
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Cantidad
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Eliminar
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            userCart.cart?.cartItems?.length > 0 ? (

                                userCart.cart?.cartItems?.map((item, idx) => (
                                    <tr key={idx} class="bg-white border-b dark:bg-navy-900 dark:border-navy-700 hover:bg-navy-200 dark:hover:bg-navy-600">
                                        <td class="p-4">
                                            <LazyLoadImage
                                                className="object-cover min-w-[45px] min-h-[45px] max-w-[45px] max-h-[45px] rounded-lg"
                                                alt={`No image`}
                                                effect="black-and-white"
                                                src={`/images/productos/${item.product.imagen}`}
                                            />
                                        </td>
                                        <td class="px-6 py-4 font-semibold text-navy-900 dark:text-white">
                                            <div>{item.product.name}</div>
                                            <div className="text-xl">{currencyFormat(item.price * item.quantity)}</div>
                                        </td>
                                        <td class="px-6 py-4">
                                            <div class="flex items-center gap-2">
                                                <Button isDisabled={item.quantity <= 1 ? true : false} isLoading={loading} onClick={() => onDecreased(item._id, item.product)} colorScheme='navy' className="rounded-full bg-brand-500 px-2 py-2 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200" type="button">
                                                    <span class="sr-only">Quantity button</span>
                                                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 2">
                                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h16" />
                                                    </svg>
                                                </Button>
                                                <div>
                                                    <input style={{ fontFamily: 'Montserrat, sans-serif', fontStyle: 'normal', letterSpacing: 0.2 }} min={1} max={10000} readOnly value={item.quantity} type="number" id="first_product" className="font-semibold flex h-10 text-center w-12 items-center justify-center rounded-xl border bg-lightPrimary dark:bg-navy-900 p-3 text-sm ring-2 focus:ring-brand-500 focus:border-brand-500 dark:focus:ring-brand-400 dark:focus:border-brand-400 outline-none border-gray-200 dark:!border-white/10 dark:text-white" placeholder="1" required />
                                                </div>
                                                <Button isDisabled={((item.quantity >= item.product.stock) && item.product.tipo === 'producto') ? true : false} isLoading={loading} onClick={() => onIncreased(item._id, item.product)} colorScheme='navy' className="rounded-full bg-brand-500 px-2 py-2 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200" type="button">
                                                    <span class="sr-only">Quantity button</span>
                                                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
                                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 1v16M1 9h16" />
                                                    </svg>
                                                </Button>
                                            </div>
                                        </td>
                                        <td class="px-6 py-4">
                                            <Button isLoading={loading} onClick={() => onRemoveFromCart(item._id)} colorScheme='red' className="rounded-full bg-red-500 px-2 py-2 text-base font-medium text-white transition duration-200 hover:bg-red-600 active:bg-red-700 dark:bg-red-400 dark:text-white dark:hover:bg-red-300 dark:active:bg-red-200" type="button">
                                                <FaTrash />
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            ) :
                                (
                                    <tr>
                                        <td colSpan={7}>
                                            <Alert
                                                className="!bg-navy-100 dark:!bg-navy-900 !text-yellow-800 dark:!text-yellow-400"
                                                variant='subtle'
                                                flexDirection='column'
                                                alignItems='center'
                                                justifyContent='center'
                                                textAlign='center'
                                                height='110px'
                                            >
                                                <AlertIcon boxSize='40px' mr={0} className="!text-brand-900 dark:!text-brand-500" />
                                                <AlertDescription maxWidth='sm' className="!text-brand-900 dark:!text-brand-500" fontSize={17}>
                                                    Puedes agregar productos con el boton de arriba o escaneando el código de barras.
                                                </AlertDescription>
                                            </Alert>
                                        </td>
                                    </tr>
                                )
                        }
                    </tbody>
                </table>
            </div>

            <div className="mt-5 flex flex-wrap gap-4">
                <FormControl className="!w-full md:!w-5/12 !mb-3 !p-2">
                    <FormLabel className="!text-sm !text-navy-700 dark:!text-white !font-bold">Descuento</FormLabel>
                    <InputGroup>
                        <InputLeftElement className="mt-[3px] ml-1 text-black dark:text-white" pointerEvents='none' fontSize='1em'>
                            PEN
                        </InputLeftElement>

                        <Input style={{ fontFamily: 'Montserrat, sans-serif', fontStyle: 'normal', letterSpacing: 0.2 }} isDisabled={userCart.cart?.descuento > 0 ? true : false} name="descuento" value={descuento} onChange={(e) => setDescuento(e.target.value)} type="number" className="font-semibold ml-1 flex !h-12 !w-44 items-center justify-center !rounded-xl border bg-lightPrimary dark:bg-navy-900 p-3 text-sm ring-2 focus:ring-brand-500 focus:border-brand-500 dark:focus:ring-brand-400 dark:focus:border-brand-400 outline-none border-gray-200 dark:!border-white/10 dark:text-white" />
                        {userCart.cart?.descuento > 0 ?
                            <Button onClick={() => {
                                onApplyDiscount(0);
                                setDescuento(0)
                            }}
                                isLoading={loading} isDisabled={userCart.cart?.cartItems?.length > 0 ? false : true} colorScheme='red' variant='solid' className="ml-2 w-36 rounded-full !h-12 bg-red-500 px-2 py-2 text-base font-medium text-white transition duration-200 hover:bg-red-600 active:bg-red-700 dark:bg-red-400 dark:text-white dark:hover:bg-red-300 dark:active:bg-red-200" type="button">
                                Eliminar
                            </Button>
                            :
                            <Button onClick={() => onApplyDiscount(descuento)}
                                isLoading={loading} isDisabled={(userCart.cart?.cartItems?.length === 0 || descuento < 1) ? true : false} colorScheme='brand' variant='solid' className="ml-2 w-36 rounded-full !h-12 bg-brand-500 px-2 py-2 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200" type="button">
                                Aplicar
                            </Button>

                        }
                    </InputGroup>
                </FormControl>
                <AutoComplete
                    extra="w-full md:w-6/12 mb-3 p-2"
                    label="Método de pago"
                    data={[
                        { code: '01', name: 'en efectivo' },
                        { code: '02', name: 'yape' },
                        { code: '03', name: 'plin' },
                        { code: '04', name: 'bim' },
                        { code: '05', name: 'depósito en cuenta' },
                        { code: '06', name: 'tarjeta de débito' },
                        { code: '07', name: 'tarjeta de crédito' },
                        { code: '08', name: 'transferencia bancaria' },
                        { code: '09', name: 'giro' }
                    ]}
                    value={metodopagoval}
                    labelProp="name"
                    valueProp="code"
                    onChange={(val) => onUpdateMetodoPago(val)}
                />
            </div>
            <div className="mt-5 flex flex-wrap gap-4">
                <div className="flex items-center justify-end w-full mt-5 md:mt-0">
                    <div style={{ fontFamily: 'Montserrat, sans-serif', fontStyle: 'normal', letterSpacing: 0.2 }} className="w-72 font-bold shadow-lg shadow-shadow-500 dark:shadow-none">
                        RESUMEN
                    </div>
                </div>
                <div className="flex items-center justify-end w-full mt-5 md:mt-0">
                    <div style={{ fontFamily: 'Montserrat, sans-serif', fontStyle: 'normal', letterSpacing: 0.2 }} className="font-semibold w-72 shadow-lg shadow-shadow-500 dark:shadow-none">
                        Ope. Gravada : {userCart.cart?.cartItems?.length > 0 ? currencyFormat((userCart.cart?.totalPrice / 1.18)) : 0}
                    </div>
                </div>
                <div className="flex items-center justify-end w-full">
                    <div style={{ fontFamily: 'Montserrat, sans-serif', fontStyle: 'normal', letterSpacing: 0.2 }} className="font-semibold w-72 shadow-lg shadow-shadow-500 dark:shadow-none">
                        I.G.V (18%) : {userCart.cart?.cartItems?.length > 0 ? currencyFormat((userCart.cart?.totalPrice - (userCart.cart?.totalPrice / 1.18))) : 0}
                    </div>
                </div>
                {userCart.cart?.descuento > 0 &&
                    <div style={{ fontFamily: 'Montserrat, sans-serif', fontStyle: 'normal', letterSpacing: 0.2 }} className="flex items-center justify-end w-full mb-5">
                        <div className={`font-semibold w-72 shadow-lg shadow-shadow-500 dark:shadow-none`}>
                            Otros DSCTO : {currencyFormat(userCart.cart?.descuento)}
                        </div>
                    </div>
                }
                <div className="flex items-center justify-end w-full mb-5">
                    <div style={{ fontFamily: 'Montserrat, sans-serif', fontStyle: 'normal', letterSpacing: 0.2 }} className={`w-72 font-bold shadow-lg shadow-shadow-500 dark:shadow-none text-lg ${userCart.cart?.descuento > 0 && '!text-red-500'}`}>
                        Importe total : {userCart.cart?.cartItems?.length > 0 ? currencyFormat((userCart.cart?.totalPrice - userCart.cart?.descuento)) : 0}
                    </div>
                </div>
            </div>
        </Card >
    )
}

export default TableCartItemsPos